module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-24.e8ef733a.png";